'use client';

import { useEffect } from 'react';

export function DataDog() {
  useEffect(() => {
    import('@/lib/datadog').then(({ initDatadog, startSessionReplay }) => {
      initDatadog();

      if (document.readyState === 'complete') {
        startSessionReplay();
      } else {
        window.addEventListener('load', startSessionReplay, { once: true });
      }
    });
  }, []);

  return null;
}
